import type { AhPayload } from '../ahReport';
import type { SwitchOption } from '@/features/dashboard/config';
import { ReportOptions } from '@/features/dashboard/components/ReportOptions';

type Campaign = AhPayload['campaign'];

type Props = {
  campaign: Campaign;
  updatedLabel: string;
  isPreview: boolean;
  onSwitch: (path: string) => void;
  switchOptions: SwitchOption[];
  onSignOut: () => void;
  isAdmin: boolean;
  onManageUsers: () => void;
};

export function TopBar({ campaign, updatedLabel, isPreview, onSwitch, switchOptions, onSignOut, isAdmin, onManageUsers }: Props) {
  return (
    <div className="topbar">
      <div className="topbar-inner">
        <div className="brand">
          <div className="brand-mark">AH</div>
          <div className="brand-text">
            <span className="label">Campagne dashboard</span>
            <span className="name">{campaign.name}</span>
          </div>
        </div>
        <div className="topbar-spacer" />
        {isPreview && <span className="ah-preview-pill">Geen live data</span>}
        <div className="last-updated">
          <span className="dot" />
          <span>Bijgewerkt {updatedLabel}</span>
        </div>
        <div className="date-range" title="Campagneperiode">
          <span>{campaign.start}</span>
          <span className="sep">→</span>
          <span>{campaign.end}</span>
        </div>
        {/* `switchOptions` ALREADY excludes the report being viewed, so one
            remaining option is a real destination. Guarding on `> 1` here (the
            threshold that belongs to a list which INCLUDES the current report,
            as ReportSwitcher's does) hid the switcher from every user with
            exactly two granted reports. */}
        {switchOptions.length > 0 && (
          <select className="ah-report-switch" value="" onChange={(e) => e.target.value && onSwitch(e.target.value)} aria-label="Wissel rapport">
            <option value="">Rapport…</option>
            <ReportOptions options={switchOptions} labels={{ active: 'Actief', archived: 'Gearchiveerd' }} />
          </select>
        )}
        {isAdmin && (
          <button className="export-btn" type="button" onClick={onManageUsers} title="Gebruikersbeheer">
            Gebruikers
          </button>
        )}
        <button className="export-btn" type="button" onClick={onSignOut} title="Uitloggen">
          Uitloggen
        </button>
      </div>
    </div>
  );
}
